<template>
  <div>
    <Layout/>
    <h4>Medios de Comunicación</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idMedioCom" class="form-label">IdMedioCom</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedioCom" name="idMedioCom" v-model="datoMedioCom.idMedioCom" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoMedioCom.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarMedioCom" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarMedioCom" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditMedioCom" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdMedioPers</th>
          <th scope="col">IdPersona</th>
          <th scope="col">IdMedioCom</th>
          <th scope="col">Descripción</th>
          <th scope="col">FechaReg</th>
          <th scope="col">Estado</th>
          <th scope="col">PersonaFechaReg</th>
          <th scope="col">Medio de Comunicación</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="mediopers in datosPaginados" :key="mediopers.idMedioPers">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(mediopers.idMedioPers)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(mediopers.idMedioPers)" title="Editar">edit_square</i></td>
          <td>{{mediopers.idMedioPers}}</td>
          <td>{{mediopers.idPersona}}</td>
          <td>{{mediopers.idMedioCom}}</td>
          <td>{{mediopers.descripcion}}</td>
          <td>{{getFormattedDate(mediopers.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{mediopers.estado}}</td>
          <td>{{getFormattedDate(mediopers.personaFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{mediopers.medioComNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteMedioCom(mediopers.idMedioPers)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idMedioPers" class="form-label">IdMedioPers</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedioPers" name="idMedioPers" v-model="datoMedioPers.idMedioPers" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idPersona" name="idPersona" v-model="datoMedioPers.idPersona"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="persona" name="persona" v-model="datoMedioPers.persona" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalPersonaLOV"
                      title="Buscar Personas">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idMedioCom" class="form-label">IdMedioCom</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedioCom" name="idMedioCom" v-model="datoMedioPers.idMedioCom" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="descripcion" name="descripcion" v-model="datoMedioPers.descripcion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoMedioPers.fechaReg" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarMedioPers" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditMedioPers" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: MedioPers -->
    <MedioPersLOVdet @DatosMedioPers="GetDataMedioPersLOVdet($event)"/>
<!-- Lista de Valores: Persona -->
    <PersonaLOVdet @DatosPersona="GetDataPersonaLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
// Listas de valores master
// Listas de valores master
// Listas de valores details
import MedioPersLOVdet from '../../components/lovs/MedioPersLOV.vue'
import PersonaLOVdet from '../../components/lovs/PersonaLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
// Listas de valores master
// Listas de valores details
, MedioPersLOVdet
, PersonaLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      mediocoms : [],
      datoMedioCom : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idMedioCom: '',
// Variables master
// Variables details
      medioperss : [],
      datoMedioPers : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idMedioCom = this.$route.params.p_idmediocom
    this.abrirEditar(this.p_idMedioCom)
    this.getMedioPerss()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      if(this.datoMedioCom.idMedioCom === ''){
        swal("Error!", "El elemento idMedioCom no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedioCom.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedioCom.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarMedioCom(){
      if(this.validarForm() === 1){
        try {
          await api.post('/mediocoms', this.datoMedioCom)
          swal("Correcto!", "MedioCom creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditMedioCom(){
      if(this.validarForm() === 1){
        try {
          await api.post('/mediocoms', this.datoMedioCom)
          swal("Correcto!", "MedioCom creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoMedioCom={}
      this.titulo   = 'Crear Medios de Comunicación'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idMedioCom){
      this.modalWindow = true
      if(idMedioCom != null){    
           api.get('/vwmediocoms/'+idMedioCom).then(resp=>{
          this.datoMedioCom = resp.data;
           });
      }
      this.titulo   = 'Editar Medios de Comunicación'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarMedioCom(){
      this.$router.push('/MedioCom')
    },
// Procedimientos master
// Procedimientos detalle
    async getMedioPerss() {
      const resp = await api.get('/medioperss')
      this.medioperss = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.medioperss.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwmedioperss/nombre/'+this.nombreBusqueda).then(response=>{
          this.medioperss=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.medioperss.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwmedioperss').then(response=>{
      this.medioperss=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.medioperss.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoMedioPers.idMedioCom === ''){
        swal("Error!", "El elemento idMedioCom no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedioPers.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedioPers.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarMedioPers(){
      if(this.validarForm() === 1){
        try {
          this.datoMedioPers.idMedioCom = this.datoMedioCom.idMedioCom;
          await api.post('/medioperss', this.datoMedioPers)
          this.getMedioPerss();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "MedioPers creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditMedioPers(){
      if(this.validarForm() === 1){
        try {
          await api.post('/medioperss', this.datoMedioPers)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "MedioPers creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoMedioPers={}
      this.titulo   = 'Crear Medios de Comunicación'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idMedioPers){
      this.modalWindow = true
      if(idMedioPers != null){    
           api.get('/vwmedioperss/'+idMedioPers).then(resp=>{
          this.datoMedioPers = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Medios de Comunicación'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idMedioPers){
      this.modalWindow = true
      if(idMedioPers != null){
        this.$router.push('/mediopersmd/'+idMedioPers)
      }
    },
    async deleteMedioPers (idMedioPers) {
      try{
        await api.delete('/medioperss/'+idMedioPers)
          this.getMedioPerss()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataMedioPersLOVdet(data) {
      this.datoMedioPers.idMedioPers = data.idMedioPers;
      this.datoMedioPers.medioPers = data.nombre;
    },
//    Lista de Valores
    GetDataPersonaLOVdet(data) {
      this.datoMedioPers.idPersona = data.idPersona;
      this.datoMedioPers.persona = data.nombre;
    },
// Listas de valores details
  },
}
</script>
